import React from 'react';
import { BridgeForm } from './BridgeForm';
import { TransactionHistory } from './TransactionHistory';
import { FaucetSection } from '../faucet/FaucetSection';
import { useBridge } from '../../hooks/useBridge';
import { useWallet } from '../../hooks/useWallet';
import { LOCAL_STORAGE_KEY } from '../../utils/constants';

export const BridgePage: React.FC = () => {
  const { walletInfo } = useWallet();
  const { 
    transactions, 
    clearTransactions,
    transactionState, // Add this to ensure re-render when transaction state changes
  } = useBridge(walletInfo.address);

  // Function to refresh transactions from localStorage
  const handleRefreshTransactions = () => {
    // Get transactions from localStorage
    if (walletInfo.address) {
      try {
        const storedTransactions = localStorage.getItem(`${LOCAL_STORAGE_KEY}-${walletInfo.address}`);
        if (storedTransactions) {
          // Force a re-render by reloading the page
          window.location.reload();
        }
      } catch (error) {
        console.error('Error loading transactions from local storage:', error);
      }
    }
  };
  
  // No need for logging anymore

  return (
    <div className="relative max-w-4xl mx-auto z-10">
      {/* Glassmorphic background elements */}
      <div className="absolute -top-20 -left-20 w-64 h-64 bg-primary-500/20 rounded-full filter blur-3xl opacity-50 animate-pulse"></div>
      <div className="absolute -bottom-20 -right-20 w-64 h-64 bg-secondary-500/20 rounded-full filter blur-3xl opacity-50 animate-pulse" style={{ animationDelay: '2s' }}></div>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary-800/10 rounded-full filter blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      <div className="grid grid-cols-1 gap-8 relative z-10">
        <div>
          <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-primary-400 to-secondary-500 mb-2 filter drop-shadow-sm">Shido Gateway</h1>
          <p className="text-gray-300 mb-6 backdrop-blur-sm bg-gray-800/10 inline-block px-3 py-1 rounded-lg">
            Transfer tokens securely between Shido and other blockchains
          </p>
          
          <BridgeForm />
        </div>
        
        {/* Faucet Section */}
        <FaucetSection />
        
        {/* Always show TransactionHistory, even when there are no transactions */}
        <TransactionHistory 
          transactions={transactions} 
          onClearHistory={clearTransactions}
          onRefresh={handleRefreshTransactions}
        />
      </div>
    </div>
  );
};
